import type { ReactElement, SVGProps } from "react";

export function CircleCheckGoldIcon(
  props: SVGProps<SVGSVGElement>
): ReactElement {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      aria-hidden
      {...props}
    >
      <circle
        cx="7"
        cy="7"
        r="7"
        fill="var(--gold-molten-mid)"
        opacity="0.15"
      />
      <path
        d="M4 7.2 L6.2 9.4 L10 5"
        stroke="var(--gold-molten-lo)"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
